import store from "@/state/store";

export default [
  {
    path: "/",
    name: "default",
    component: () => import("./views/landing")
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/dashboards/saas/index"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        
        let token = await localStorage.getItem('authToken');
        // If the user is already logged in
        if (token) {

          // Redirect to the home page instead
          return store.dispatch('auth/validate').then((validUser) => {
            // Then continue if the token still represents a valid user,
            // otherwise redirect to login.
            console.log('valid user', validUser)
            validUser ? next({ name: "dashboard" }) : next()
          })

        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch("auth/logOut");
        
        // Navigate back to previous page, or home as a fallback
        next({ name: 'default' });
      },
    },
  },
  {
    path: "/404",
    name: "404",
    component: require("./views/utility/404").default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "404",
  },
  {
    path: "/profile",
    name: "Profile",
    meta: { authRequired: true },
    component: () => import("./views/profile/index"),
  },
  {
    path: "/calendar",
    name: "Calendar",
    meta: { authRequired: true },
    component: () => import("./views/calendar/calendar"),
  },
  {
    path: "/users/list",
    name: "User List",
    meta: { authRequired: true, isAdmin: true },
    component: () => import("./views/users/list"),
  },
  {
    path: "/rooms/list",
    name: "Room List",
    meta: { authRequired: true, isAdmin: true },
    component: () => import("./views/rooms/list"),
  },
  {
    path: "/years/list",
    name: "Year List",
    meta: { authRequired: true, isAdmin: true },
    component: () => import("./views/years/list"),
  },
  {
    path: "/years/show/:id",
    name: "Show Year Report",
    meta: { authRequired: true, isAdmin: true },
    component: () => import("./views/years/show"),
  },
  {
    path: "/items/list",
    name: "Item List",
    meta: { authRequired: true, isAdmin: true },
    component: () => import("./views/items/list"),
  },
  {
    path: "/subjects/list",
    name: "Subject List",
    meta: { authRequired: true, isAdmin: true },
    component: () => import("./views/subjects/list"),
  },
  {
    path: "/posts/list",
    name: "Posts List",
    meta: { authRequired: true },
    component: () => import("./views/posts/list"),
  },
  {
    path: "/posts/create",
    name: "Create Post",
    meta: { authRequired: true },
    component: () => import("./views/posts/create"),
  },
  {
    path: "/posts/edit/:id",
    name: "Edit Post",
    meta: { authRequired: true },
    component: () => import("./views/posts/edit"),
  }
];